
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[date]",
      function () {
        return require("private-next-pages/[date].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[date]"])
      });
    }
  